import {FUINavigationLoader, FUINavigationTree} from "@fedelta-pos/ui";
import {Observable, Subject} from "rxjs";
import {HttpClient} from "@angular/common/http";

export class NavigationLoader implements FUINavigationLoader {

    private static readonly HOS_PATH: string = "assets/navigator/navigator.json";

    constructor(private httpClient: HttpClient) {
    }

    loadNavigation(): Observable<FUINavigationTree[]> {
        const subject: Subject<FUINavigationTree[]> = new Subject<FUINavigationTree[]>();

        this.httpClient.get(NavigationLoader.HOS_PATH).subscribe((trees: Object[]) => {
          const navigationTrees: FUINavigationTree[] = trees.map(tree => new FUINavigationTree(tree));
          subject.next(navigationTrees);
        });

        return subject;
    }
}
